export default __webpack_public_path__ + "static/media/2455.006a176f.png";